import Grid from '@mui/material/Grid'
import CampaignRequestedDetail from './CampaignRequestedDetail'
import CampaignRequestedVouchers from './CampaignRequestedVouchers'

const CampaignRequestedShow = () => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <CampaignRequestedDetail />
    </Grid>
    <Grid item xs={12}>
      <CampaignRequestedVouchers />
    </Grid>
  </Grid>
)

export default CampaignRequestedShow
